// eslint-disable-next-line react-hooks/exhaustive-deps
const wordSeparatorRegEx =
  /(!([^\s0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+|\s|[-–@.,][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+/gim;

const clearValueToFilterWord = (value = '') => {
  return value
    .trim()
    .replace(/^[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+/gim, '')
    .replace(/[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+$/gim, '');
};
export const wordCounter = (value) => {
  const cleanValue = clearValueToFilterWord(value);
  if (!cleanValue) {
    return 0;
  }
  const splittedValue = cleanValue.split(wordSeparatorRegEx);
  const filteredVaue = splittedValue.filter(
    (val) => !!clearValueToFilterWord(val),
  );
  const { length } = filteredVaue;
  return length;
};
